import actionCreatorFactory from "typescript-fsa"; // FSA = Flus Standard Actions; has properties type, payload, error (whether payload is error object; optional) and meta (optional).

import * as toastr from "toastr";

import * as types from "./actionTypes";

import { IRecurrence } from "../classes/recurrencePattern";

import { DataService } from "../data/DataService";
import { beginAjaxCall } from "./ajaxActions";

const dataService = new DataService();

export function clearUpdatedRecurrencePatternDescription() {
  return (dispatch) => {
    dispatch(clearUpdatedRecurrencePatternDescriptionAction());
  };
}

export function clearUpdatedRecurrencePattern() {
  return (dispatch) => {
    dispatch(clearUpdatedRecurrencePatternAction());
  };
}

export function loadUpdatedRecurrencePattern(recurrence: IRecurrence, dateOfFirstEventInRecurrence: Date, firstDayOfWeek: string) {
  return (dispatch) => {

    dispatch(beginAjaxCall());

    return dataService.updateRecurrenceDescription(recurrence, dateOfFirstEventInRecurrence, firstDayOfWeek).then((response: any) => {

      if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.

      if (response.error && response.error !== "") {
        toastr.error(response.error);
      } else {
        const updatedRecurrenceDescription: string = response.recurrenceDescriptionText;
        dispatch(loadUpdatedRecurrencePatternDescriptionSuccessAction(updatedRecurrenceDescription));
        dispatch(updateRecurrencePatternAction(recurrence));
      }
    });
  };
}

export function setOpenRecurrenceModal(open: boolean) {
  return (dispatch) => {
    dispatch(setOpenRecurrenceModalAction(open));
  };
}

// Actual action creators:

const actionCreator = actionCreatorFactory();

export const clearUpdatedRecurrencePatternDescriptionAction = actionCreator(types.CLEAR_UPDATED_RECURRENCE_PATTERN_DESCRIPTION);
export const clearUpdatedRecurrencePatternAction = actionCreator(types.CLEAR_UPDATED_RECURRENCE_PATTERN);
export const loadUpdatedRecurrencePatternDescriptionSuccessAction = actionCreator<string>(types.LOAD_UPDATED_RECURRENCE_PATTERN_DESCRIPTION_SUCCESS);
export const setOpenRecurrenceModalAction = actionCreator<boolean>(types.SET_OPEN_RECURRENCE_MODAL);
export const updateRecurrencePatternAction = actionCreator<IRecurrence>(types.UPDATE_RECURRENCE_PATTERN);
